// Unpublished Work © 2021-2022 Deere & Company

import * as actions from '../../action-list';
import {FacetOptions} from '../../state/struct/customer-search/facets/facet-options';
import {adaptFacetLabelsFromAddressElements} from '../../services/facets';

const setFacets = (state, action) => {
    const {
        addressElements,
        states,
        countries,
        customerTypes,
        cityAsDropdown,
        useTaxId
    } = action.facetOptions;

    return FacetOptions.update(state, {
        $merge: {
            ...adaptFacetLabelsFromAddressElements(addressElements),
            states,
            countries,
            customerTypes,
            cityAsDropdown,
            useTaxId
        }
    });
};

const updateStatesAndAddressElementsOptions = (state, action) =>
    FacetOptions.update(state, {
        $merge: {
            ...adaptFacetLabelsFromAddressElements(action.addressElements),
            cityAsDropdown: action.cityAsDropdown,
            useTaxId: action.useTaxId,
            states: action.states
        }
    });

const resetFacetOptionsToDefault = (state, action) =>
    FacetOptions.update(state, {
        $merge: {
            ...action.addressLabels,
            states: action.states
        }
    });

const setCitiesFacets = (state, action) => FacetOptions.update(state, {
    $merge: {
        cities: action.cities
    }
});

export const facetOptions = (state = new FacetOptions({}), action = {}) => {
    const actionHandlers = {
        [actions.UPDATE_STATES_AND_ADDRESS_ELEMENTS_IN_SEARCH_FACETS]: updateStatesAndAddressElementsOptions,
        [actions.SET_CUSTOMER_SEARCH_FACETS]: setFacets,
        [actions.SET_CITY_FACET]: setCitiesFacets,
        [actions.RESET_FACETS_TO_DEFAULTS]: resetFacetOptionsToDefault
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
